import { APP_VERSION, CoreAppState } from '@aa/angular/core';
import { CustomerAppLayoutComponent } from '@aa/angular/customer';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';
import LogRocket from 'logrocket';
import * as CookieConsent from 'vanilla-cookieconsent';
import { MatButtonModule } from '@angular/material/button';
import * as Sentry from '@sentry/angular';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    CustomerAppLayoutComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private matIconReg: MatIconRegistry,
    private readonly toastr: ToastrService,
    private readonly store: Store<CoreAppState>,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  ngOnInit(): void {
    console.log('APP VERSION', APP_VERSION);
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.update();
      });
    }
  }

  ngAfterViewInit() {
    CookieConsent.run({
      onConsent: () => {
        if (CookieConsent.acceptedCategory('analytics')) {
          if (environment.production) {
            LogRocket.init('au1iyf/the-card-professor');

            Sentry.init({
              dsn: 'https://e794561ae2f9d5750ad26072b1e325f6@o4507376112566272.ingest.us.sentry.io/4507959547723776',
              sendDefaultPii: true,
            });
          }
        } else {
        }
      },
      autoShow: true,
      guiOptions: {
        consentModal: {
          position: 'bottom left',
        },
        preferencesModal: {
          position: 'left',
        },
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {},
      },
      language: {
        default: 'en',
        translations: {
          en: {
            consentModal: {
              title: 'We use cookies',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              showPreferencesBtn: 'Manage Individual preferences',
            },
            preferencesModal: {
              title: 'Manage cookie preferences',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              savePreferencesBtn: 'Accept current selection',
              closeIconLabel: 'Close modal',
              sections: [
                {
                  title: 'Strictly Necessary cookies',
                  description:
                    'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Performance and Analytics',
                  description:
                    'These cookies collect information about how you use our website.',
                  linkedCategory: 'analytics',
                },
                {
                  title: 'More information',
                  description:
                    'For any queries in relation to my policy on cookies and your choices, please <a href="mailto:contact@mycardprofessor.com">contact us</a>',
                },
              ],
            },
          },
        },
      },
    });
  }
}
